import React from "react";
import counterpart from "counterpart";
export const DefaultOperation = ({
  op
}) => {
  console.log("unimplemented op:", op);
  return /*#__PURE__*/React.createElement("span", null, counterpart.translate("operation.unknown_operation"), " ", op[0]);
};